export default {
  methods: {
    HTTPKnowledgeCapacity() {
      return new Promise((resolve, reject) => {
        this.axios.get('/knowledge/getStorageSpace').then(res => {
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
